import { ProColumns } from '@ant-design/pro-components';
import { Checkbox, Form, Input, message } from 'antd';
import CustomButton from 'base/ui/components/Button';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { cloneDeep, findIndex } from 'lodash';
import { observer } from 'mobx-react';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CustomerCRMModel } from 'services/Main/customerSegment_services';

import {
  contactSegmentPresenter,
  contactSegmentStore
} from 'stores/root_store';
import { MVC_URL, PAGE_SIZE_DEFAULT } from 'utils/constants';

import * as Icon from 'base/ui/components/Icons';
import usePartialState from 'hooks/usePartialState';
import { getPlantCode } from 'utils/localStorageHelper';


type GeneralTabProps = {
  contactSegmentationId: string;
};

function GeneralTab(props: GeneralTabProps) {
  const { contactSegmentationId } = props;
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const navigate = useNavigate();



  // =============================================================================================================================
  const [checkAll, setCheckAll] = useState(false)

  const columnsCRM: ProColumns<CustomerCRMModel>[] = [
    //  stt
    {
      title: t('zalo-notification.stt'),
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 50,
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Mã CRM (Tên liên hệ)
    {
      title: 'Mã liên hệ',
      dataIndex: 'crmCode',
      key: 'crmCode',
      fixed: 'left',
      width: 100,
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Mã CRM khách hàng
    {
      title: 'Mã CRM khách hàng',
      dataIndex: 'crmCodeCustomer',
      key: 'crmCodeCustomer',
      fixed: 'left',
      width: 100,
      onCell: (_, index) => ({
        className: 'text-center',
      }),
      render(text, record) {
        return <a target='_blank' href={`${MVC_URL}/Customer/Profile/Edit/${record.customerIdByContact}`} rel="noreferrer" >{text}</a>
      },
    },
    // Tên liên hệ
    {
      title: 'Tên liên hệ',
      dataIndex: 'customerName',
      key: 'customerName',
      width: 200,
      render(text, record) {
        return <a target='_blank' href={`${MVC_URL}/Customer/Profile/Edit/${record.profileId}`} rel="noreferrer" >{text}</a>
      },
    },
    // Tên Khách hàng
    {
      title: 'Tên khách hàng',
      dataIndex: 'customerNameByContact',
      key: 'customerNameByContact',
      width: 200,
      render(text, record) {
        return <a target='_blank' href={`${MVC_URL}/Customer/Profile/Edit/${record.customerIdByContact}`} rel="noreferrer" >{text}</a>
      },
    },
    // phòng ban
    {
      title: 'Phòng ban',
      dataIndex: 'departmentName',
      key: 'departmentName',
      width: 250,
      ellipsis: true
    },
    // Chức vụ
    {
      title: 'Chức vụ',
      dataIndex: 'position',
      key: 'position',
      width: 250,
      ellipsis: true
    },
    // NV phụ trách
    {
      title: 'NV phụ trách',
      dataIndex: 'salesEmployeeInCharge',
      key: 'salesEmployeeInCharge',
      width: 250,
      ellipsis: true
    },
    // Số điện thoại
    {
      title: t('segment.sdt'),
      dataIndex: 'phone',
      key: 'phone',
      width: 150,
    },
    // Email
    {
      title: t('segment.email'),
      dataIndex: 'email',
      key: 'email',
      width: 200,
    },
    //   Chi nhánh
    // {
    //   title: t('segment.chi-nhanh'),
    //   dataIndex: 'address',
    //   key: 'address',
    //   width: 150,
    // },
    //  Ghi chú
    // {
    //   title: t('segment.ghi-chu'),
    //   dataIndex: 'description',
    //   key: 'description',
    //   width: 250,
    // },
    //   Người tạo
    {
      title: t('segment.nguoi-tao'),
      dataIndex: 'createBy',
      key: 'address',
      width: 200,
    },
    //   Ngày tạo
    {
      title: t('segment.ngay-tao'),
      dataIndex: 'createTime',
      key: 'createTime',
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY HH:mm:ss',
      },
      width: 200,
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Trạng thái
    {
      title: t('segment.trang-thai'),
      dataIndex: 'actived',
      key: 'actived',
      width: 150,
      render: (_, record) =>
        record.actived ? (
          <Icon.CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
        ) : (
          <Icon.CloseStatus width="14" className="!fill-red-500 block mx-auto" />
        ),
    },
    // không Chăm sóc
    // {
    //   title: t('segment.khong-cs'),
    //   dataIndex: 'address',
    //   key: 'address',
    //   width: 120,
    //   render: (text, record) => <div className='flex justify-center'>
    //     <Checkbox />
    //   </div>,
    // },
    // Chăm sóc đặc biệt
    {
      title: (
        <div className='flex gap-2 justify-center items-center'>
          <Checkbox checked={checkAll} onChange={(e) => {
            const dataClone = cloneDeep(dataCustomerCRM)
            const newArr = dataClone.map(item => {
              return {
                ...item,
                isSpecialCare: e.target.checked
              }
            })
            setCheckAll(e.target.checked)
            setDataCustomerCRM(newArr)
          }} />
          {t('segment.cs-db')}
        </div>
      ),
      dataIndex: 'isSpecialCare',
      key: 'isSpecialCare',
      width: 160,
      render: (text, record) => <div className='flex justify-center'>
        <Checkbox checked={record.isSpecialCare}
          onChange={(e) => {
            const index = findIndex(dataCustomerCRM, ['id', record.id])
            if (index !== -1) {
              const dataClone = cloneDeep(dataCustomerCRM)
              const recordClone = cloneDeep(record)
              recordClone.isSpecialCare = e.target.checked
              dataClone[index] = recordClone


              // kiểm tra check phần tử để hiện check all cho đúng
              const check = dataClone.find(item => item.isSpecialCare)
              if (check) {
                setCheckAll(true)
              } else {
                setCheckAll(false)
              }


              setDataCustomerCRM(dataClone)
            }
          }}
        />
      </div>,
    },
  ];

  // phân trang khách hàng crm
  const [dataPagingCRM, setDataPagingCRM] = useState<SearchModel>({
    type: 'KHCRM',
    contactSegmentationId: contactSegmentationId,
    customerCode: getPlantCode(),
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
  });
  // số record crm
  const [totalCountCRM, setTotalCountCRM] = useState(0);

  // ============================================================ STATE ==========================================================
  const [reportState, setReportState] = usePartialState({
    loading: false,
  });

  // data khách hàng trên crm
  const [dataCustomerCRM, setDataCustomerCRM] = useState<CustomerCRMModel[]>([]);
  // lấy data khách trên crm
  const getDataTableCustomerCRM = async (dataSearch: SearchModel) => {
    await contactSegmentPresenter.getCustomerOfContactSegment(contactSegmentStore, dataSearch);
    if (contactSegmentStore.customerOfContactSegment.isSuccess) {
      setDataCustomerCRM(contactSegmentStore.customerOfContactSegment.data?.listKH);
      setTotalCountCRM(contactSegmentStore.customerOfContactSegment.paging?.totalCount || 0);
      form.setFieldsValue({
        contactSegmentName: contactSegmentStore.customerOfContactSegment.data.contactSegmentName,
        description: contactSegmentStore.customerOfContactSegment.data.description,
        companyCode: contactSegmentStore.customerOfContactSegment.data.companyCode,
      })

      return contactSegmentStore.customerOfContactSegment.data.listKH;
    }
    return [];
  };
  // ================================ LẤY DROPDOWN ===========================================================

  return (
    <div className="mt-3">

      <div className='flex justify-end mb-2'>
        <CustomButton
          onClick={async () => {
            let dataSave = {}
            let listKH = dataCustomerCRM.map(item => {
              return {
                idCustomer: item.id,
                isSpecialCare: item.isSpecialCare
              }
            })
            Object.assign(dataSave, {
              ...form.getFieldsValue(),
              listKH: listKH,
              id: contactSegmentationId,
              companyCode: getPlantCode()
            })

            await contactSegmentPresenter.editContactSegment(contactSegmentStore, dataSave)
            if (contactSegmentStore.createContactSegment.isSuccess) {
              message.success(contactSegmentStore.createContactSegment.message)
              navigate('/Customer/ContactSegmentation')
            }
          }}
          type="primary"
        >
          {t('btn.save')}
        </CustomButton>
      </div>

      <SearchForm
        form={form}
        onFinish={(value) => { }}
        column="col-2"
        className='!mb-4'
      >
        {/* Contact segment */}
        <SearchItem name={'contactSegmentName'} label={'Contact segment'}>
          <Input />
        </SearchItem>
        {/* Mô tả */}
        <SearchItem name={'description'} label={'Mô tả'}>
          <Input />
        </SearchItem>
      </SearchForm>

      <CustomProTable<CustomerCRMModel>
        bordered
        columns={columnsCRM}
        dataSource={dataCustomerCRM}

        scroll={{ x: 2000, y: 450 }}

        tableAlertRender={false}
        // rowSelection={{
        //   columnWidth: 150,
        //   columnTitle: <div className='flex gap-2'>
        //     <span>Chăm sóc đặc biệt</span>
        //     <Checkbox
        //       checked={!!selectedRowKeys.length}
        //       indeterminate={
        //         selectedRowKeys.length > 0 && selectedRowKeys.length < dataCustomerCRM!.length
        //       }
        //       onChange={toggleSelectAll}
        //     />
        //   </div>,
        //   selectedRowKeys: selectedRowKeys,
        //   onSelect: handleSelect,
        // }}

        toolBarRender={() => [
          // EXPORT =================================================================
          <CustomButton
            loading={reportState.loading}
            onClick={async () => {
              setReportState({ loading: true });
              await contactSegmentPresenter.exportExcel({
                contactSegmentationId: contactSegmentationId,
              })
              setReportState({ loading: false });
            }}
            icon={<Icon.Download className={'!fill-dark'} />}
          >
            {t('btn.export')}
          </CustomButton>]}

        request={async (params = {}, sort, filter) => {
          const data = await getDataTableCustomerCRM({
            ...dataPagingCRM,
            paging: {
              ...dataPagingCRM.paging,
              orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
              orderByDesc:
                Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
            },
          });

          if (Object.values(sort).length) {
            setDataPagingCRM({
              ...dataPagingCRM,
              paging: {
                ...dataPagingCRM.paging,
                orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                orderByDesc:
                  Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
              },
            });
          }
          return {
            data: data,
            success: contactSegmentStore.customerOfContactSegment.isSuccess,
          };
        }}
        // pagination={false}
        rowKey="stt"
        pagination={{
          ...tablePagination(dataPagingCRM, setDataPagingCRM),
          total: contactSegmentStore.customerOfContactSegment.data?.pagingSP?.totalCount,
        }}
        options={{
          setting: false,
          density: false,
          fullScreen: false,
          reload: false,
        }}
      />

    </div>
  );
}

export default observer(GeneralTab);
